// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"7c9c19c6","256":"fbabaa0c","396":"6a65f4a3","493":"6323fb74","599":"56f6b991","650":"80ba4a70","832":"d7e3d456"}[chunkId] + ".chunk.js";
};